import React from "react";
import type { IssuesSelectionProps } from "./types";

export const IssuesSelection: React.FC<IssuesSelectionProps> = ({
  options,
  selectedIssues,
  onToggle,
}) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="w-full mb-2 sm:mb-3">
      <p className="text-xs font-semibold mb-1.5 text-left w-full">
        What didn't go well? (Optional)
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
        {options.map((issue) => (
          <button
            key={issue.id}
            type="button"
            onClick={() => onToggle(issue.id)}
            className={`text-[10px] sm:text-xs py-1 sm:py-1.5 px-1.5 sm:px-2 rounded-md border transition-colors text-center cursor-pointer active:scale-95 ${
              selectedIssues.includes(issue.id)
                ? "bg-[#10333B] text-white border-[#10333B]"
                : "bg-white text-[#10333B] border-gray-200 hover:border-[#10333B]"
            }`}
          >
            {issue.label}
          </button>
        ))}
      </div>
    </div>
  );
};

